// ─────────────────────────────────────────────────────────────
// The issuance lock a desktop restore left (#688), from
// GET /api/license/restore-lock (any signed-in user). The API writes the
// notice; the screen shows it as is.
// ─────────────────────────────────────────────────────────────
import { useQuery } from '@tanstack/react-query';
import { useBillingApi } from '../../billing-host/api';

/**
 * VERIFICATION: a restore is being checked against the MCF; READ_ONLY: the
 * restored data could not be checked, no invoice and no sale.
 */
export type RestoreLockState = 'VERIFICATION' | 'READ_ONLY';

export interface RestoreLockStatus {
  locked: boolean;
  state: RestoreLockState | null;
  /** French notice shown on every screen; null when nothing is locked. */
  notice: string | null;
}

export const restoreLockKeys = {
  status: () => ['restore-lock'] as const,
};

/** GET /api/license/restore-lock — drives the restore banner of every screen. */
export function useRestoreLock() {
  const api = useBillingApi();
  return useQuery({
    queryKey: restoreLockKeys.status(),
    queryFn: () => api.get<RestoreLockStatus>('/license/restore-lock'),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });
}
